export const mutations = {
    setResponse(state, response) {
        state.response = response;
    },
};

export default mutations;
